import { useState } from "react";
import Dropdown from "../Elements/Dropdown";
import ProgressBar from "../Elements/ProgressBar";
import { TbEdit, TbTrash, TbEye } from "react-icons/tb";
import Popup from "../Elements/Popup";
import { useNavigate, Link } from "react-router-dom";
import PropTypes from "prop-types";

const GoalCardOneRow = ({ goalMilestones, title, onEdit, onDelete, goal, customDropdown, titleSize = "md:text-sm text-base", hideDropdown = false }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false); // manage popup state
  const navigate = useNavigate();

  const progressPercentage =
    goalMilestones.length > 0
      ? Math.round(
          (goalMilestones.filter((milestone) => milestone.status === true)
            .length /
            goalMilestones.length) *
            100
        )
      : 0;

  const handleDeleteConfirm = () => {
    onDelete(goal.id); // call the delete function passed from parent
    setConfirmDeleteOpen(false); // close popup after confirming
  };

  const defaultDropdown = [
    {
      text: "View",
      onClick: () => navigate(`/goals/${goal.id}`),
      icon: <TbEye />,
    },
    {
      text: "Edit",
      onClick: () => onEdit(goal),
      icon: <TbEdit />,
    },
    {
      text: "Delete",
      onClick: () => setConfirmDeleteOpen(true), // open popup instead of deleting immediately
      icon: <TbTrash />,
    },
  ];

  const goalDropdown = customDropdown || defaultDropdown;

  return (
    <>
      <Link
        to={`/goals/${goal.id}`}
        className="relative px-3 py-2 card-base-background card-base flex flex-row items-center gap-4 card-base-border hover:shadow-lg transition-shadow cursor-pointer group"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div className="flex flex-col md:flex-row gap-1 w-full">
          <p
            className={`flex-1 basis-0 font-medium ${titleSize}`}
            title={title}
          >
            {title}
          </p>
          <div className="flex-1 md:max-w-80 w-full flex justify-center">
            <ProgressBar
              width={`${progressPercentage}%`}
              percentage={progressPercentage}
            />
          </div>
        </div>

        {!hideDropdown && (
          <div className="ml-4 z-10" onClick={(e) => e.preventDefault()}>
            <Dropdown
              options={goalDropdown}
              isOpen={dropdownOpen}
              onOpenChange={setDropdownOpen}
            />
          </div>
        )}
      </Link>

      {/* Delete confirmation popup */}
      <Popup
        isOpen={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        title="Delete Goal"
        description="Are you sure you want to permanently delete this goal?"
        buttonSecondaryCTA="Cancel"
        onClickSecondaryLink={() => setConfirmDeleteOpen(false)}
        buttonPrimaryCTA="Delete"
        onClickPrimaryLink={handleDeleteConfirm}
      />
    </>
  );
};

GoalCardOneRow.propTypes = {
  goalMilestones: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  goal: PropTypes.object.isRequired,
  titleSize: PropTypes.string,
  hideDropdown: PropTypes.bool,
};

export default GoalCardOneRow;
